import { useMutation } from '@tanstack/react-query';
import {
  generateOperatorReport,
  generateOperatorReportParams,
} from '../../services/backendService';

/**
 * Hook for generating an operator report using TanStack Query
 * @returns Mutation object for generating the report
 */
export const useGenerateOperatorReport = () => {
  return useMutation({
    mutationKey: ['generateOperatorReport'],
    mutationFn: (params: generateOperatorReportParams) => generateOperatorReport(params),
  });
};
